import * as MuiIcons from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import * as Mui from "@mui/material";
import { useContext, useEffect } from "react";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import { ContextDamageForm } from "./DamageFormContext";

import { ContextOperation } from "../../context/OperationContext";
import DamageFormService from "./service/DamageFormService";
interface Props {
  open: boolean;
  onClose: () => void;
  updateDatasourceDamage: () => void;
  onSelectionchange: () =>void;
  //damageFormIds:any;
}

const SendBilling = (props: Props) => {
  const {setLoading} = useContext(ContextOperation);
  const snackbar = useSnackbar();
  const t = useOperationTranslation();
  const {tenant} = useContext(ContextOperation);

  const damageFormContext = useContext(ContextDamageForm);
 
  useEffect(() => {
    
  }, []);


  const sendBill =() =>{
    let damageFormIds = damageFormContext.damageFormIds;
    setLoading(true);
      DamageFormService.list.put.updateBill(tenant,{damageFormIds}).then(response=>{
        props.updateDatasourceDamage();
        props.onClose();
        setLoading(false);
        snackbar.show("success", t("damageForm.fotBilling.successMessage"));
      },(error:any)=>{
        setLoading(false);
        snackbar.show("error", t("damageForm.fotBilling.errorMessage"));
       
      });
  
      damageFormContext.setDamageFormIds([]);

  }
 
  const onClose = () => {
     props.onClose();
  };

  return (
    <Mui.Dialog open={props.open} onClose={onClose} fullWidth maxWidth="sm">
    <Mui.DialogTitle>
      <Mui.Grid container alignItems="center">
        <Mui.Grid item xs="auto">
         
          <Mui.Grid xs="auto" item>
            <Mui.Button variant="text" size="icon" color ="accent">
            <InfoIcon />  {" "} <Mui.Typography variant="h6">{t("damageForm.fotBilling.title")}</Mui.Typography>
            </Mui.Button>
            </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid item xs="auto" marginLeft="auto">
          <Mui.Button variant="text" size="icon" onClick={onClose}>
            <MuiIcons.Close color="action"/>
          </Mui.Button>
        </Mui.Grid>
      </Mui.Grid>
    </Mui.DialogTitle>
    <Mui.DialogContent>
      <Mui.Typography
       style={{ whiteSpace: "pre-line" }}>
        {t("damageForm.fotBilling.messageBody")}
      </Mui.Typography>
    </Mui.DialogContent>
    <Mui.DialogActions>
      <Mui.Grid container justifyContent="end" spacing="16px">
        <Mui.Grid item xs="auto" height='48px'>
          <Mui.Button variant="outlined"  size="smallPlus"   onClick={onClose}>
            <Mui.Typography color={'accent'} variant="h6">
            {t("vehicleEquipmentAssociation.dialogs.editAcriss.actions.cancel")}
            </Mui.Typography>
          </Mui.Button>
        </Mui.Grid>
        <Mui.Grid item xs="auto">
          <Mui.Button onClick ={sendBill} size="smallPlus">
           <Mui.Typography color={'accent'} variant="h6">
           {t("damageForm.fotBilling.sendButton")}
            </Mui.Typography> 
          </Mui.Button>
        </Mui.Grid>
      </Mui.Grid>
    </Mui.DialogActions>
  </Mui.Dialog>
  );
};

export default SendBilling;
